import type { PopoverProps } from "@mantine/core";
import { Button, Group, Popover, Stack, Text, Textarea, Title } from "@mantine/core";
import type { ReactNode } from "react";

export default function SessionFeedbackPopover({
  children,
  comment,
  mode,
  opened,
  onDismiss,
  onSubmit,
  onCancel,
  onCommentChange,
  loading
}: {
  children: ReactNode;
  comment: string;
  mode: "positive" | "negative";
  opened: boolean;
  onDismiss: VoidFunction;
  onSubmit: () => void;
  onCancel: VoidFunction;
  onCommentChange: (value: string) => void;
  loading?: boolean;
} & PopoverProps) {
  return (
    <Popover
      trapFocus
      withArrow={false}
      position="top-start"
      withOverlay
      opened={opened}
      closeOnEscape
      closeOnClickOutside
      returnFocus
      onDismiss={onDismiss}
    >
      <Popover.Target>
        <div>{children}</div>
      </Popover.Target>
      <Popover.Dropdown>
        <Stack gap="md" w={500}>
          <Stack gap="xs">
            <Title order={4}>
              {mode === "positive" ? "What did you like about this session?" : "How can we improve this session?"}
            </Title>
            <Text c="dimmed" size="sm">
              Your feedback helps the AI improve. Only your feedback will be sent to SDLabs (Atinary) to help improve
              the AI.
            </Text>
          </Stack>
          <Textarea
            value={comment}
            onChange={e => onCommentChange(e.currentTarget.value)}
            maxLength={4000}
            autosize
            minRows={3}
            maxRows={4}
            placeholder={
              mode === "positive"
                ? "What did you like about this session?"
                : "Describe what went wrong and what you expected to happen instead."
            }
            autoFocus
          />
          <Group gap={5} justify="flex-end">
            <Button variant="subtle" color="gray" onClick={onCancel}>
              Cancel
            </Button>
            <Button onClick={onSubmit} loading={loading}>
              Send
            </Button>
          </Group>
        </Stack>
      </Popover.Dropdown>
    </Popover>
  );
}
